// extracted by mini-css-extract-plugin
export var labelWrapper = "_f2-0";